module.exports = __webpack_public_path__ + "static/seo-adact-7add4626c53290f568d1937e2da4b48a.png";